// extracted by mini-css-extract-plugin
export default {"linkSizableDefault":"v3LH5","large":"W6idh","wide":"TFxta"};